export default __webpack_public_path__ + "static/media/CNo.82-8.7715ac4d.jpg";